var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5444 10.3026C16.5444 14.0677 13.5033 17.1051 9.77026 17.1051C6.03719 17.1051 2.99609 14.0677 2.99609 10.3026C2.99609 6.5374 6.03719 3.5 9.77026 3.5C13.5033 3.5 16.5444 6.5374 16.5444 10.3026ZM15.01 18.579C13.4957 19.5453 11.6981 20.1051 9.77026 20.1051C4.37214 20.1051 -0.00390625 15.7164 -0.00390625 10.3026C-0.00390625 4.88876 4.37214 0.5 9.77026 0.5C15.1684 0.5 19.5444 4.88876 19.5444 10.3026C19.5444 12.6971 18.6883 14.8912 17.2663 16.5936L23.4804 22.8511L21.3665 24.9797L15.01 18.579Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b1a813272e714047a06ab659a39a3bb7.svg";
export { ForwardRef as ReactComponent };